"use strict";
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
var styles = {
    rootIsFixed: 'rootIsFixed_41cfeb6a',
    content: 'content_41cfeb6a',
};
load_themed_styles_1.loadStyles([{ "rawString": ".rootIsFixed_41cfeb6a{position:fixed;z-index:1000000;top:0;left:0;width:100vw;height:100vh;visibility:hidden}.content_41cfeb6a{visibility:visible}" }]);
module.exports = styles;
/* tslint:enable */ 

//# sourceMappingURL=Layer.scss.js.map



//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib/components/Layer/Layer.scss.js
// module id = 256
// module chunks = 0